export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/v4/video/icon-sound-on-f3f45cf1dd5f5397cfed3c0bec742dbd.svg";